import React from "react"
import { useMenu } from 'react-instantsearch';
import { sortBy } from "lodash"
import classNames from "classnames"
import ReactSelect from "react-select"
const optionClassNames = (isSelected, hasValue, label, placeholder) => classNames("configurator-select__option", {
	"configurator-select__option--is-selected": isSelected || (!hasValue && label === placeholder),
})

const ReactSelectOption = ({ innerProps, innerRef, label, isSelected, hasValue, selectProps }) =>
(<div className={optionClassNames(isSelected, hasValue, label, selectProps.placeholder)} ref={innerRef} {...innerProps} >{label}</div>)

const optionsWithUnit = (items, unit = "") => items.map(item => ({ ...item, label: `${item.label}${unit}` }))

function Select({ attributeName, heading, modelName, modelCode, defaultRefinement, unit }){
  const { items, refine } = useMenu({ attribute: attributeName });
   // console.log( items )
    if(!items.length)
    {
        return null;
    }
    const onChange = ( selectedOption ) => {	
    
        refine(selectedOption.value)
		window.dataLayer.push({
			event: "product-tab",
			productName: modelName,
			productCode: modelCode,
			productTab: "specify",
			productDropdown: heading,
		})
    } 
    return (<div className={`configurator__field ${attributeName === "ostendoAccessories"
                 ? "configurator__field--static" : ""}`} >
        <label htmlFor={attributeName}>{heading}</label>
        <ReactSelect
            {...(attributeName === "ostendoAccessories" ? { maxMenuHeight: 200 } : {})}
            classNamePrefix="configurator-select"
            className="configurator-select"
            placeholder="Please Select"
            name={attributeName}
            components={{ DropdownIndicator: null, Option: ReactSelectOption }}
            isSearchable={false}
            defaultValue={defaultRefinement}
            options={sortBy(optionsWithUnit(items, unit), item => item.label)}
            value={optionsWithUnit(items, unit).filter(item => item.isRefined === true) || null}
            onChange={onChange}
        />

    </div>)
}
export default Select